<template>
  <div class="page aboutqb">
    <navigation class="custom-navigation" sticky>关于我们</navigation> 
        
    <div class="header">
      <img src="./images/logo_qianbao.png">

      <div class="title">天美钱包 </div>

      <div class="slogan">贴心的记账管家</div>
    </div>

    <div class="content">
      <div class="title">依托合规平台，服务安全可靠</div>
      <p>天美钱包是重庆市崇天小额贷款有限公司旗下产品，以互联网安全技术及大数据挖掘、智能严密的技术为支点，为您提供贴心安全的记账提醒服务。</p>

      <div class="title">及时贴心的记账管理</div>
      <p>天美钱包以专业的数据统计分析、强大的云端数据库、丰富的账本管理工具，随时支持账本数据云同步，时刻保障数据安全，记账服务更及时贴心。</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'aboutqb',

  description: '关于天美钱包'
}
</script>
<style lang="less">
@import "../../assets/less/mixin.less";

    .aboutqb {
        background-color: #FAFAFA;
        padding-bottom: 45px;

        .custom-navigation {
            background: linear-gradient(270deg, #FF6E34 0%, #FF8939 100%);
        }

        .header {
            height: 524px;
            background: linear-gradient(90deg, #FF934A 0%, #FFC157 100%);
            overflow: hidden;
            text-align: center;
            color: #FFFFFF;

            img {
                height: 100px;
                width: 100px;
                margin-top: 72px;
            }

            .title {
                line-height: 45px;
                font-size: 32px;
                margin-top: 15px;
                font-family: PingFangSC-Medium,PingFang SC;
                font-weight: 500;
            }

            .slogan {
                font-size: 24px;
                line-height: 33px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
            }
        }

        .content {
            margin: -192px 30px 0;
            padding: 0 35px 90px;
            border-radius: 20px;
            background-color: #FFFFFF;
            overflow: hidden;

            .title {
                margin-top: 90px;
                font-size: 32px;
                font-family: PingFangSC-Semibold,PingFang SC;
                font-weight: 600;
            }

            p {
                margin-top: 12px;
                font-size: 26px;
                line-height: 33px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                color: @fc2;
            }
        }
    }
</style>